export const riskyPluralize = (input: string, count?: number) => {
  if (count === 1) {
    return input;
  }

  if (input === 'data') {
    return 'data';
  }

  if (input.endsWith('y')) {
    return `${input.slice(0, -1)}ies`;
  }

  if (input.endsWith('s')) {
    return `${input}es`;
  }

  return `${input}s`;
};
